import React from 'react';
import jwt_decode from 'jwt-decode';
import Modal from '../../components/Modals/Modal';
import WarningIcon from '../../components/Icons/outline/WarningIcon';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import RedButton from '../../components/Buttons/RedButton';
import { COLORS } from '../../config';
import useApp from '../../store/app/appContext';

const TIME_DELAY_UNTIL_LOGOUT = 60; 
const TIME_INTERVAL_TO_CHECK_TOKEN = 30000; 

function TokenExpiry() {
  const [seconds, setSeconds] = React.useState(null);
  const countdownRef = React.useRef(null);
  const { logout, refreshToken } = useApp();

  const _onClickExtend = async () => {
    await refreshToken();
    setSeconds(null);
  };

  const _onClickCancel = () => setSeconds(null);

  // Countdown timer once inside the TIME_DELAY_UNTIL_LOGOUT
  React.useEffect(() => {
    if (countdownRef.current) clearTimeout(countdownRef.current);

    if (typeof seconds === 'number' && seconds <= TIME_DELAY_UNTIL_LOGOUT && seconds > 0) {
      countdownRef.current = setTimeout(() => setSeconds(seconds - 1), 1000);
    }

    if (typeof seconds === 'number' && seconds <= 0) logout();
  }, [seconds]);

  // Poll token every X seconds and check expiration
  React.useEffect(() => {
    const checkExpiration = () => {
      const token = localStorage.getItem('jwtToken');
      if (!token) return;

      try {
        const decoded = jwt_decode(token);
        const now = Math.floor(Date.now() / 1000);
        const diff = decoded.exp - now;

        if (diff <= 0) {
          logout();
        } else if (diff <= TIME_DELAY_UNTIL_LOGOUT) {
          setSeconds(diff); // triggers countdown
        } else {
          setSeconds(null); // clear modal if refreshed in time
        }
      } catch (err) {
        console.error('Invalid token:', err);
        logout();
      }
    };

    checkExpiration(); // initial check
    const interval = setInterval(checkExpiration, TIME_INTERVAL_TO_CHECK_TOKEN);

    return () => clearInterval(interval);
  }, []);

  if (!seconds || seconds > TIME_DELAY_UNTIL_LOGOUT) return null;

  return (
      <Modal className='min-w-1/2' title={'Warning'} show={true} hide={_onClickCancel}>
        <div className='flex flex-col justify-between my-8'>
          <WarningIcon className='h-12 w-12 self-center mb-4 -mt-4' stroke={ COLORS.deleteRed } />
          <>
            <p className='mb-4 text-center'>
              <strong>Access token expiring</strong>
            </p>
            <p className='mb-4'>
              Do you want to renew your access token?
            </p>
            <p> 
              If you do not extend your token, you will be logged out automatically in{' '} {seconds} seconds.
            </p>
          </>
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <SecondaryButton onClick={_onClickCancel} text='Cancel'/>
          <RedButton onClick={_onClickExtend} text={'Extend'} />
        </div>
      </Modal>
  )
}

export default TokenExpiry
